import { Component, Input, OnInit } from '@angular/core';
import type { FiatFees } from 'src/app/models/exchange-fees';
import { Country } from 'src/app/models/country';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'fees-fiat',
    templateUrl: './fees-fiat.component.html',
    styleUrls: ['./fees-fiat.component.scss', '../fees-page/fees-page.component.scss'],
    standalone: false
})
export class FeesFiatComponent implements OnInit {
  @Input() fiatFees: FiatFees;
  @Input() fiatCurrency: String;
  @Input() country: Country;
  ccPercentage = '3.675%';
  higherCcFeesCountries = ['KWT', 'BHR', 'QAT', 'OMN'];
  countryWithdrawFiatFees: { [key: string]: any } = {};

  constructor() { }

  ngOnInit(){
    this.countryWithdrawFiatFees = environment.countries;
    if (environment.countries.hasOwnProperty(this.country?.code3)){
      this.ccPercentage = environment.countries[this.country?.code3].ccFees;
    }
  }
}
